import { Link } from 'gatsby';
import React from 'react';

interface LogoProps {
  uri: string;
}

export const Logo: React.FC<LogoProps> = ({ uri = 'http://www.siemens.com' }) => (
  <Link
    className="cue-project-brand"
    to={uri}
    // target="_blank"
    aria-label={`open ${uri}`}></Link>
);
